import React from 'react'

const TextInput = ({type, placeholder, name, value, onChange, label, required}) => (
    <div className="form-group">
        <input
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
        />
        { label ? <label><small>{label}</small></label> : null }
    </div>
)

export default TextInput



// WEBPACK FOOTER //
// ./src/components/form/TextInput.js